module.exports = __webpack_public_path__ + "img/logo-house-medium-3.de040ea2.svg";